const dateFormat = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
});

window.okeReviewsWidgetOnInit = function () {
    const warButton = document.querySelector(".okeReviews-reviewsWidget-header .js-okeReviews-writeReview");
    const controlsSelect = document.querySelector(".okeReviews-reviews .okeReviews-reviews-controls-sort");
    if (warButton && controlsSelect) {
        controlsSelect.insertAdjacentElement("afterend", warButton);
    }
  
    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const observerConfig = {
            childList: true
        };
        const observer = new MutationObserver(() => {
			moveAggregateSide();
            formatReviewDate();
        });
        observer.observe(reviewMain, observerConfig);
  		moveAggregateSide();
        formatReviewDate();
    }
};

window.okeReviewsQandaOnInit = function () {
	const questionMain = document.querySelector('.js-okeReviews-questions-main');
    if (questionMain) {
        const observerConfig = {
            childList: true
        };
        const observer = new MutationObserver(() => {
            formatReviewDate();
        });
        observer.observe(questionMain, observerConfig);
        formatReviewDate();
    }
};

function moveAggregateSide() {
    const customAggregate = document.querySelector(".okeReviews-custom-aggregate");
    const aggregateSide = document.querySelector(".okeReviews-reviewsAggregate-side");
    if (customAggregate && aggregateSide) {
        customAggregate.appendChild(aggregateSide);
    }
}

function formatReviewDate() {
    const reviewDates = document.querySelectorAll('[data-oke-reviews-date]');
    for (const reviewDate of reviewDates) {
        const dateIsoString = reviewDate.getAttribute('data-oke-reviews-date');
        const date = new Date(dateIsoString);
        const localeDate = `${dateFormat.format(date)}`;
        reviewDate.innerText = localeDate;
    }
}